module.exports = __webpack_public_path__ + "img/backyard-bushes-by-water.32704512.jpg";